// extracted by mini-css-extract-plugin
export default {"title":"EvaluationDetail_title__jD9QD","table":"EvaluationDetail_table__3jIk5"};